import { Box, Card, CardContent, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import type { AskCitation } from "@/types/marketReport";

function formatPageRange(
  pageStart: number | null,
  pageEnd: number | null,
): string | null {
  if (pageStart == null) return null;
  if (pageEnd == null || pageEnd === pageStart) return `p. ${pageStart}`;
  return `pp. ${pageStart}–${pageEnd}`;
}

export function CitationList({ citations }: { citations: AskCitation[] }) {
  if (citations.length === 0) return null;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, mt: 2 }}>
      <Typography variant="subtitle2" color="text.secondary">
        Sources
      </Typography>
      {citations.map((citation, index) => {
        const pageRange = formatPageRange(
          citation.page_start,
          citation.page_end,
        );
        return (
          <Card key={`${citation.report_id}-${index}`} variant="outlined">
            <CardContent sx={{ py: 1.5, "&:last-child": { pb: 1.5 } }}>
              <Typography variant="subtitle2">
                <Link
                  component={RouterLink}
                  to={`/market-reports/reports/${citation.report_id}`}
                  underline="hover"
                >
                  {citation.citation_label}
                </Link>
                {pageRange ? (
                  <Typography
                    component="span"
                    variant="body2"
                    color="text.secondary"
                    sx={{ ml: 1 }}
                  >
                    ({pageRange})
                  </Typography>
                ) : null}
              </Typography>
              {citation.supporting_excerpt ? (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mt: 0.5, fontStyle: "italic" }}
                >
                  "{citation.supporting_excerpt}"
                </Typography>
              ) : null}
            </CardContent>
          </Card>
        );
      })}
    </Box>
  );
}
